import { useMutation, useQueryClient } from '@tanstack/react-query';

import { flowsheetUrl } from './api';
import { clientApi } from '@/config/axios';
import type { ClinicalEvent } from './types';
import { useAuth } from '@/lib/auth/AuthContext';

export interface VisitSigningInput {
  device_id: string;
  entries: { root_id: string; expected_head_id: string; client_seq: number }[];
  reason: string;
}

export function useVisitSigning(episodeId: string) {
  const { organization } = useAuth();
  const orgId = organization?.organization_id;
  const cache = useQueryClient();
  return useMutation({
    onSuccess: () => cache.invalidateQueries({ queryKey: ['clinical-events', orgId, episodeId] }),
    mutationFn: async ({ input, encounterId }: { encounterId: string; input: VisitSigningInput }) => {
      if (!orgId) throw new Error('Select a practice before signing');
      return (
        await clientApi.post<ClinicalEvent[]>(
          `${flowsheetUrl(orgId)}/episodes/${episodeId}${encounterId === '__all__' ? '' : `/encounters/${encounterId}`}/sign`,
          input,
        )
      ).data;
    },
  });
}
